export default __webpack_public_path__ + "static/media/0004.94c7a50b.png";